import inputmask from "inputmask";

window.validEmail = (email) => {
    const emailRegular = /\S{2,20}@\S{3,20}\.\S{2,7}/;
    return emailRegular.test(email)
}

export const checkEmail = (inputLabel) => {
  const input = inputLabel.querySelector(".input-container__input")
  inputmask('email').mask(input)

  const acceptEmail = () => {
    const checkEmail = window.validEmail(input.value)
    checkEmail ?  inputLabel.classList.remove('input-container--error') : inputLabel.classList.add('input-container--error')
    return checkEmail
  }

  return {
    acceptEmail
  }
  
}